import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import { TournamentLink } from '../../../shared/components/Sport/SportLinks';

const PrematchTournamentLink = ({ tournament, isActive }) => {
  const tournamentRef = useRef(null);

  return (
    <div
      className={cx(['tournament-list__item', isActive && 'active'])}
      ref={isActive ? tournamentRef : null}
    >
      <TournamentLink
        className='tournament-list__link'
        sportUrlName={tournament.sportUrlName}
        categoryUrlName={tournament.categoryUrlName}
        tournamentUrlName={tournament.urlName}
      >
        {tournament.categoryName}
      </TournamentLink>
    </div>
  );
};

export default PrematchTournamentLink;
